// 采购人拜访记录 采购人名片上传
import OSS from 'ali-oss'

async function upload(file) {
    var file = file;
    var fileSize = 10000000;
    var typeArr = "image/png,image/jpg,image/gif,image/jpeg";
    var type = file.name.split('.')[1];
    var storeAs = 'webABP/' + new Date().getTime() + '.' + type;
    var boolean = true;
    var myurl = '';
    if (file.size > fileSize) {
        Toast('图片不能超过!' + size / 1000 + 'kb');
        return false;
    }
    if (typeArr && typeArr.indexOf(type) > 0) {
        boolean = false;
    }
    if (boolean) {
        Toast('上传图片格式不支持!请选择' + this.typeArr);
        return false;
    }
    const client = new OSS({
        region: 'oss-cn-shenzhen',
        accessKeyId: 'LTAIzhtY7YkzfLhX',
        accessKeySecret: 'DLhuLBMBjDL5mSip4NujpeBHV8GS0s',
        bucket: 'wxsmall',
        secure: true, //设置为 https
    })
    await client.multipartUpload(storeAs, file).then(function(result) {
        console.log("get", result.name) //返回的路径  
        myurl = result.name;
    }).catch(function(err) {
        console.log("err", err);
    });
    return Promise.resolve(myurl)
}
export { upload }